exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/shared/save-template/save-template.component.css
// module id = ../../../../../src/app/components/organization/captive-portal/shared/save-template/save-template.component.css
// module chunks = main